import { extend, localize } from 'vee-validate';

import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_spaces as rule_alpha_spaces,
  alpha_num as rule_alpha_num,
  length as rule_length
} from 'vee-validate/dist/rules';
import tr from 'vee-validate/dist/locale/tr.json';
import en from 'vee-validate/dist/locale/en.json';

// eslint-disable-next-line object-curly-newline
import {
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorCreditCard,
  validatorGreaterThanZero
} from './validators';

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required);

export const email = extend('email', rule_email);

export const min = extend('min', rule_min);

export const confirmed = extend('confirmed', rule_confirmed);

export const regex = extend('regex', rule_regex);

export const between = extend('between', rule_between);

export const alpha = extend('alpha', rule_alpha);

export const integer = extend('integer', rule_integer);

export const digits = extend('digits', rule_digits);

export const alphaDash = extend('alpha-dash', rule_alpha_dash);

export const alphaSpaces = extend('alpha_spaces', rule_alpha_spaces);

export const alphaNum = extend('alpha-num', rule_alpha_num);

export const length = extend('length', rule_length);

export const positive = extend('positive', {
  validate: validatorPositive
});

export const greaterThanZero = extend('greaterThanZero', {
  validate: validatorGreaterThanZero
});

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!'
});

export const password = extend('password', {
  validate: validatorPassword,
  message:
    'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit'
});

export const url = extend('url', {
  validate: validatorUrlValidator
});

export const uppercase_and_digit = extend('uppercase_and_digit', {
  validate: value => {
    const pattern = /^(?=.*[A-Z])(?=.*\d).+$/;
    return pattern.test(value);
  }
});

export const doubleOrInteger = extend('doubleOrInteger', {
  validate: value => {
    const decimalRegex = /^\d+(\.\d+)?$/;
    return decimalRegex.test(value);
  }
});

export const alphaInvoice = extend('alphaInvoice', {
  validate: value => {
    const decimalRegex = /^[a-zA-Z0-9-]*$/;
    return decimalRegex.test(value);
  }
});

export const alphaReference = extend('alphaReference', {
  validate: value => {
    const decimalRegex = /^[a-zA-Z0-9]+$/;
    return decimalRegex.test(value);
  }
});

export const json = extend('json', {
  validate: value => {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  }
});

extend('greaterThanMin', {
  validate: (value, [min_val]) => {
    const minVal = parseFloat(min_val);
    const maxVal = parseFloat(value);
    if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
      return false;
    }
    return maxVal >= minVal;
  }
});

const currentLocale = localStorage.getItem('locale');
// eslint-disable-next-line no-unused-vars
let { messages } = tr;
messages.uppercase_and_digit = '{_field_} en az 1 büyük harf ve 1 rakam içermelidir';
messages.integer = '{_field_} alanı yalnızca sayılardan oluşmalıdır';
messages.doubleOrInteger =
  '{_field_} alanı yalnızca sayılardan veya ondalık sayılardan oluşmalıdır';
messages.alphaInvoice = '{_field_} alanı yanlızca sayı, harf ve " - " işaretinden oluşmalıdır.';
messages.alphaReference = '{_field_} alanı yanlızca sayı ve harflerden oluşmalıdır.';
messages.positive = "{_field_} alanı 0'dan düşük bir değer içermemelidir";
messages.greaterThanZero = "{_field_} alanı 0'dan büyük olmalıdır";
messages.json = '{_field_} alanı JSON tipinde olmalı';
messages.url = 'URL geçersiz';
messages.greaterThanMin = '{_field_} değeri "Minimum Değerden" küçük olamaz.';

if (currentLocale && currentLocale === 'en') {
  messages = en.messages;
  messages.uppercase_and_digit = '{_field_} must contain at least one uppercase and one digit';
  messages.integer = 'The {_field_} field must consist of numbers only';
  messages.doubleOrInteger = '{_field_} field should consist of numbers or decimal numbers';
  messages.alphaInvoice =
    '{_field_} field should only consist of numbers, letters, and "-" symbol.';
  messages.alphaReference = '{_field_} field should only contain alphanumeric characters.';
  messages.positive = '{_field_} field should not contain a value less than 0.';
  messages.greaterThanZero = '{_field_} field must be greater than 0.';
  messages.json = '{_field_} field must be JSON type';
  messages.url = 'URL is invalid';
  messages.greaterThanMin = 'The {field} value cannot be less than the minimum value.';
}

// Install English and Turkish localizations.
localize({
  en: {
    messages,
    names: {
      email: 'Email',
      password: 'Password'
    },
    fields: {
      password: {
        min: '{_field_} is too short.'
      }
    }
  }
});
